module.exports = __webpack_public_path__ + "img/logo.701422a1.png";